var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bet-control",
    transform: "translate(-354.000000, -604.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(354.000000, 604.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4034043,6.74978723 C12.0340426,6.61276596 11.6229787,6.80340426 11.4859574,7.17276596 C11.1821277,8.00085106 9.18042553,8.89446809 6.47574468,8.89446809 C3.84255319,8.89446809 1.8706383,8.04851064 1.4893617,7.23234043 C1.32255319,6.87489362 0.893617021,6.72 0.536170213,6.88680851 C0.178723404,7.05361702 0.0238297872,7.48255319 0.190638298,7.84 C0.887659574,9.3293617 3.41361702,10.3242553 6.47574468,10.3242553 C7.93531915,10.3242553 9.35319149,10.0859574 10.4791489,9.64510638 C11.7182979,9.16255319 12.5344681,8.47744681 12.8323404,7.6612766 C12.9634043,7.29787234 12.772766,6.88680851 12.4034043,6.74978723 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4034043,10.3957447 C12.0340426,10.2587234 11.6229787,10.4493617 11.4859574,10.8187234 C11.1821277,11.6468085 9.18042553,12.5404255 6.47574468,12.5404255 C3.84255319,12.5404255 1.8706383,11.6944681 1.4893617,10.8782979 C1.32255319,10.5208511 0.893617021,10.3659574 0.536170213,10.532766 C0.178723404,10.6995745 0.0238297872,11.1285106 0.190638298,11.4859574 C0.887659574,12.9753191 3.41361702,13.9702128 6.47574468,13.9702128 C7.93531915,13.9702128 9.35319149,13.7319149 10.4791489,13.2910638 C11.7182979,12.8085106 12.5344681,12.1234043 12.8323404,11.307234 C12.9634043,10.9378723 12.772766,10.5268085 12.4034043,10.3957447 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47574468,1.26990617e-15 C2.78212766,1.26990617e-15 2.53981233e-15,1.43574468 2.53981233e-15,3.34212766 C2.53981233e-15,5.24851064 2.78212766,6.68425532 6.47574468,6.68425532 C10.1693617,6.68425532 12.9514894,5.24851064 12.9514894,3.34212766 C12.9514894,1.43574468 10.1693617,1.26990617e-15 6.47574468,1.26990617e-15 Z M6.47574468,5.25446809 C3.39574468,5.25446809 1.42978723,4.12255319 1.42978723,3.34212766 C1.42978723,2.56170213 3.39574468,1.42978723 6.47574468,1.42978723 C9.55574468,1.42978723 11.5217021,2.56170213 11.5217021,3.34212766 C11.5217021,4.12255319 9.55574468,5.25446809 6.47574468,5.25446809 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.32688342a92e5b8c99248ad46257f18f.svg";
export { ForwardRef as ReactComponent };